import styled from "styled-components";
import theme from "../../../styles/theme";

import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useGetStaticItemSum } from "../../../interface/item";
import { useState } from 'react';
import { NumericFormatCustom } from "../dashboard/common";
import CommonDataGrid from "../../common/CommonDataGrid";
import { useGetCategoryList } from "../../../interface/common";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        margin: 0;
        color: ${theme.color.black};
    }
`;

const staticItemColumn = [
    { field: 'pcat_nm', headerName: '구분', width:100},
    { field: 'cat_nm', headerName: '분류', width:120},
    // { field: 'chart', headerName: '현황', width:250, renderCell:ChartStaticItem },
    // { field: 'tot_cnt', headerName: '전체', width:90, renderCell:NumericFormatCustom },
    { field: 'vtot_cnt', headerName: '전체', width:90, renderCell:NumericFormatCustom },
    { field: 'n_cnt', headerName: '정상', width:90, renderCell:NumericFormatCustom },
    { field: 'b_cnt', headerName: '고장/파손', width:90, renderCell:NumericFormatCustom },
    { field: 'p_cnt', headerName: '수리', width:90, renderCell:NumericFormatCustom },
    { field: 'r_cnt', headerName: '임대', width:90, renderCell:NumericFormatCustom },
    { field: 'x_cnt', headerName: '분실', width:90, renderCell:NumericFormatCustom },
    { field: 's_cnt', headerName: '판매', width:90, renderCell:NumericFormatCustom },
    { field: 't_cnt', headerName: '폐기', width:90, renderCell:NumericFormatCustom },
    { field: 'w_cnt', headerName: '소멸', width:90, renderCell:NumericFormatCustom },
    { field: 'z_cnt', headerName: '기타', width:90, renderCell:NumericFormatCustom },
    { field: 'm2_inc_cnt', headerName: '전전월 증가', width:90, renderCell:NumericFormatCustom },
    { field: 'm1_inc_cnt', headerName: '전월 증가', width:90, renderCell:NumericFormatCustom },
    { field: 'm0_inc_cnt', headerName: '당월 증가', width:90, renderCell:NumericFormatCustom },
    { field: 'm2_dec_cnt', headerName: '전전월 감소', width:90, renderCell:NumericFormatCustom },
    { field: 'm1_dec_cnt', headerName: '전월 감소', width:90, renderCell:NumericFormatCustom },
    { field: 'm0_dec_cnt', headerName: '당월 감소', width:90, renderCell:NumericFormatCustom },
]

const StaticItem = () => {

    const [searchParams] = useSearchParams();

    const [cid, setCid] = useState(searchParams.get('cid'));

    const [list, setList] = useState([]);
    const [pCatelist, setPCateList] = useState([]);

    const {data: staticItemSum, isLoading: staticItemSumLoading, refetch} = useGetStaticItemSum({cid:cid});
    const {data : categoryList} = useGetCategoryList();

    useEffect(()=>{
        if(staticItemSum){
            const temp = staticItemSum.filter((item)=> item.cid !== null);
            setList(temp.map((item,index)=>({id:index,...item})));
        }
    },[staticItemSum])

    useEffect(()=>{
        if(categoryList && categoryList[0]){
        const temp = categoryList[0].filter((item)=>item.pcid===null);
        setPCateList(temp)}
    },[categoryList])

    useEffect(()=>{
        refetch();
    },[cid])

    return (
        <MainWrap>
            <h3>자산현황</h3>
            <FormControl style={{width:'10rem',margin:'16px 0px'}} size='small'>
                <InputLabel id='status-label'>구분</InputLabel>
                <Select label="구분" labelId='status-label' size='small' defaultValue={cid}>
                    <MenuItem value={''} onClick={()=>setCid('')} >없음</MenuItem>
                    {pCatelist && pCatelist.map((item,index)=>{
                        return <MenuItem 
                                    key={index} 
                                    value={item.cid} 
                                    onClick={()=>setCid(item.cid)}
                                >
                                    {item.cat_nm}
                                </MenuItem>
                    })}
                </Select>
            </FormControl>
            <div style={{height:'80vh'}}>
            <CommonDataGrid
                    isLoading={staticItemSumLoading}
                    list={list}
                    columns={staticItemColumn}
                    showCount={list.length}
                />
                </div>
        </MainWrap>
    )

}

export default StaticItem;